<template>
  <div style="width:100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

	
    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="house.houseTypeName" label="物业类型" label-width="130px" readonly autosize rows='1' type="textarea"/>
        <van-field v-model="house.code" 
			:label="(house.buildingType == 2 || house.buildingType == 3?'房间号':(house.buildingType == 4?'车位':(house.buildingType == 5?'场地名称':'广告位编码')))" 
			label-width="130px" readonly autosize rows='1' type="textarea"/>
        <van-field v-model="house.name" 
			:label="(house.buildingType == 2 || house.buildingType == 3?'房间名称':(house.buildingType == 4?'车位名称':(house.buildingType == 5?'场地位置':'广告位位置')))" label-width="130px" readonly autosize rows='1' type="textarea"/>
        <van-field v-model="house.propertyArea" 
			:label="(house.buildingType == 4 ? '车位面积（㎡）' : [2,3].includes(house.buildingType) ? '建筑面积（㎡）' : '面积（㎡）')" label-width="130px" readonly autosize rows='1' type="textarea"/>
        <van-field v-model="inputForm.bunkName" label="铺位名称" label-width="130px" readonly autosize rows='1' type="textarea"/>
        <van-field v-model="inputForm.startDate" label="开始日期" label-width="130px" readonly autosize rows='1' type="textarea"/>
        <van-field v-model="inputForm.propertyArea" label="出租面积（㎡）" label-width="130px" readonly autosize rows='1' type="textarea"/>
        <van-field v-if="inputForm.status == 2" v-model="inputForm.outDate" label="实际撤场日期" label-width="130px" readonly autosize rows='1' type="textarea"/>
		<van-field v-model="inputForm.state" label="物业使用状态" label-width="130px" readonly autosize rows='1' type="textarea"/>
	  </van-collapse-item>
      <van-collapse-item title="附件" name="2">
		<div v-if="inputForm.status != 2">
      <p>进场附件</p>
      <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
<!--          <p>进场附件</p>-->
<!--          <a class="m-row" style="display: block; color: #4caedc" v-for="file in inputForm.attachList" :href="file.url">{{file.name}}</a>-->
          <div class="m-row" v-if="inputForm.attachList && inputForm.attachList.length==0">无</div>
		</div>  
		<div v-if="inputForm.status == 2">
      <p>撤场附件</p>
      <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.outAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
<!--		  <p>撤场附件</p>-->
<!--		  <a class="m-row" style="display: block; color: #4caedc" v-for="file in inputForm.outAttachList" :href="file.url">{{file.name}}</a>-->
		  <div class="m-row" v-if="inputForm.outAttachList && inputForm.outAttachList.length==0">无</div>
        </div>
      </van-collapse-item>
    </van-collapse>
	<h4>手机端不显示应收明细，请至PC端查看</h4>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import CustomerMarchService from "@/api/wuye/CustomerMarchService";
import processRecord from "../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2'],
      isshow: false,
      radio: '',
      inputForm: {
        id: '',
        houseId: '',
        houseCustomerId: '',
        bunkName: '',
        startDate: '',
        endDate: '',
        outDate: '',
        state: '',
        status: '1',
        isDoTask: false,
        isLastTask: false
      },
	  house: {
	  },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(this.businessId)
    // this.init('1775347836580937729')
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      new CustomerMarchService().queryById(id).then(({data}) => {
        this.inputForm = data
		
		this.$flow.queryById(data.houseId, '/base/wuyeBaseHouse/queryById').then(({ data }) => {
		  this.house = data
		  this.house.code = (house.projectName + '-' + house.buildingName + (house.buildingType == 3?"-" + (house.isShowUnit == "0"?"":house.unit+ "-"):"-") + house.code)
		}).catch(e => {
		  console.log(e)
		})
		this.inputForm.state = data.state==1?'自用':(data.state==2?'出租':'空置')
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        _this.auditForm.message = _this.inputForm.remarks

        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'wuye_base_house_customer_march',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: _this.inputForm.isLastTask ? 4 : 2,
				formKey: _this.formKey
			}
            new CustomerMarchService().startFlow(form);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: 3,
				formKey: _this.formKey
			}
            new CustomerMarchService().startFlow(form);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
